import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UploadIcon from "../../Assets/Images/Upload icon.svg";
import { theme } from "../../Assets/Theme/theme";

const UploadVideosComponent = ({ onChange, initialVideos = [] }) => {
  const [videos, setVideos] = useState(initialVideos);

  const handleUploadVideo = async (event) => {
    const files = Array.from(event.target.files); 
    if (files.length > 0) {
      const base64Videos = await Promise.all(files.map(file => convertToBase64(file)));
      console.log(base64Videos, "VIDEO OF BASE 64");
      const updatedVideos = [...videos, ...base64Videos];
      
      setVideos(updatedVideos);
      onChange(updatedVideos);
    }
  };

  const convertToBase64 = (file) => {
    console.log(file, "FILE");
    
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleRemoveVideo = (indexToRemove) => {
    const updatedVideos = videos.filter((_, index) => index !== indexToRemove);
    setVideos(updatedVideos);
    onChange(updatedVideos);
  };

  return (
    <Box
      sx={{
        border: `1px solid #ccc`,
        padding: "16px 16px 0",
        borderRadius: "8px",
        width: "100%",
      }}
    >
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
        {videos.map((video, index) => (
          <Box
            key={index}
            sx={{
              position: "relative",
              border: "1px solid #ccc",
              borderRadius: "8px",
              overflow: "hidden",
              width: { xs: "45%", md: "250px" },
              height: { xs: "150px", md: "250px" },
            }}
          >
            {/* Close Icon */}
            <IconButton
              onClick={() => handleRemoveVideo(index)}
              sx={{
                position: "absolute",
                top: "4px",
                right: "4px",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                color: "white",
                zIndex: 2,
                "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
              }}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            <video
              src={video}
              controls
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          </Box>
        ))}

        <Box
          sx={{
            border: `2px solid ${theme.colors.orange}`,
            borderRadius: "8px",
            width: { xs: "45%", md: "250px" },
            height: { xs: "150px", md: "250px" },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            cursor: "pointer",
          }}
        >
          <input
            type="file"
            accept="video/*"
            multiple
            onChange={handleUploadVideo}
            style={{
              opacity: 0,
              position: "absolute",
              width: "100%",
              height: "100%",
              cursor: "pointer",
            }}
          />
          <Box
            sx={{
              textAlign: "center",
              pointerEvents: "none",
            }}
          >
            <img src={UploadIcon} alt="Upload" />
            <Typography variant="body2" sx={{ color: "#121212" }}>
              Upload Your Videos
            </Typography>
          </Box>
        </Box>
      </Box>

      <Typography
        variant="body2"
        sx={{ textAlign: "right", mb: "2px", color: "#121212" }}
      >
        Videos Attached: {videos.length}
      </Typography>
    </Box>
  );
};

export default UploadVideosComponent;
